export const isTabletOrIpad = function () {
    let check = false;
    (function (a) {
        if (/(ipad|macintosh.*?tablet|android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk.*$/i.test(
            a
        )) {
            check = true;
        }
    })(navigator.userAgent || navigator.vendor || window.opera);

    return check;
};
export default isTabletOrIpad;
